import(/* webpackMode: "eager", webpackExports: ["UniversityGalleryClient"] */ "/app/app/(students)/students/universities/[slug]/components/UniversityGalleryClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
